//backup
module.exports = {
    BubblesData: () => {
        return [[{
            name:"96",
            tipo:"96",
            verts:[[580.749,451.684]]
            },{
            name:"73",
            tipo:"73",
            verts:[[729.224,506.743]]
            },{
            name:"72",
            tipo:"72",
            verts:[[860.585,555.153]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1134.57,654.678]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1192.42,324.557]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1338.38,344.063]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1453.65,359.237]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1660.13,385.515]]
            },],[{
            name:"96",
            tipo:"96",
            verts:[[593.464,438.29]]
            },{
            name:"73",
            tipo:"73",
            verts:[[711.935,494.794]]
            },{
            name:"72",
            tipo:"72",
            verts:[[818.596,545.459]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1046.82,652.897]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1224.34,325.076]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1364.91,347.03]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1477.96,364.501]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1685.09,395.816]]
            },],[{
            name:"96",
            tipo:"96",
            verts:[[609.702,425.699]]
            },{
            name:"73",
            tipo:"73",
            verts:[[700.008,482.772]]
            },{
            name:"72",
            tipo:"72",
            verts:[[782.438,534.727]]
            },{
            name:"49",
            tipo:"49",
            verts:[[962.465,647.547]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1256.31,326.029]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1391.14,350.42]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1501.51,370.232]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1708.3,406.799]]
            },],[{
            name:"96",
            tipo:"96",
            verts:[[628.925,413.925]]
            },{
            name:"73",
            tipo:"73",
            verts:[[693.073,470.846]]
            },{
            name:"72",
            tipo:"72",
            verts:[[752.23,523.245]]
            },{
            name:"49",
            tipo:"49",
            verts:[[883.442,639.04]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1288.31,327.426]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1417,354.257]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1524.15,376.468]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1729.42,418.559]]
            },],[{
            name:"96",
            tipo:"96",
            verts:[[650.675,402.963]]
            },{
            name:"73",
            tipo:"73",
            verts:[[690.739,459.149]]
            },{
            name:"72",
            tipo:"72",
            verts:[[727.943,511.263]]
            },{
            name:"49",
            tipo:"49",
            verts:[[811.338,627.815]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1320.32,329.284]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1442.4,358.57]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1545.71,383.244]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1748.02,431.166]]
            },],[{
            name:"96",
            tipo:"96",
            verts:[[674.58,392.803]]
            },{
            name:"73",
            tipo:"73",
            verts:[[692.627,447.782]]
            },{
            name:"72",
            tipo:"72",
            verts:[[709.448,498.998]]
            },{
            name:"49",
            tipo:"49",
            verts:[[747.369,614.324]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1352.31,331.635]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1467.21,363.394]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1565.97,390.595]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1763.55,444.665]]
            },],[{
            name:"49",
            tipo:"49",
            verts:[[692.264,599.089]]
            },{
            name:"72",
            tipo:"72",
            verts:[[696.45,486.653]]
            },{
            name:"73",
            tipo:"73",
            verts:[[698.296,436.831]]
            },{
            name:"96",
            tipo:"96",
            verts:[[700.27,383.422]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1384.25,334.493]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1491.32,368.746]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1584.72,398.539]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1775.46,459.075]]
            },],[{
            name:"49",
            tipo:"49",
            verts:[[646.451,582.557]]
            },{
            name:"72",
            tipo:"72",
            verts:[[688.667,474.387]]
            },{
            name:"73",
            tipo:"73",
            verts:[[707.395,426.358]]
            },{
            name:"96",
            tipo:"96",
            verts:[[727.487,374.806]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1416.09,337.904]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1514.55,374.666]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1601.64,407.102]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1783.04,474.381]]
            },],[{
            name:"49",
            tipo:"49",
            verts:[[609.939,565.192]]
            },{
            name:"72",
            tipo:"72",
            verts:[[685.714,462.343]]
            },{
            name:"73",
            tipo:"73",
            verts:[[719.542,416.413]]
            },{
            name:"96",
            tipo:"96",
            verts:[[755.977,366.933]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1447.74,341.898]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1536.72,381.178]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1616.42,416.29]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1785.53,490.53]]
            },],[{
            name:"49",
            tipo:"49",
            verts:[[582.37,547.433]]
            },{
            name:"72",
            tipo:"72",
            verts:[[687.132,450.644]]
            },{
            name:"73",
            tipo:"73",
            verts:[[734.34,407.029]]
            },{
            name:"96",
            tipo:"96",
            verts:[[785.493,359.77]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1479.16,346.495]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1557.64,388.293]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1628.74,426.094]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1782.21,507.433]]
            },],[{
            name:"49",
            tipo:"49",
            verts:[[563.265,529.622]]
            },{
            name:"72",
            tipo:"72",
            verts:[[692.523,439.379]]
            },{
            name:"73",
            tipo:"73",
            verts:[[751.48,398.23]]
            },{
            name:"96",
            tipo:"96",
            verts:[[815.87,353.298]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1510.22,351.74]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1577.05,396.033]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1638.21,436.502]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1772.23,524.939]]
            },],[{
            name:"49",
            tipo:"49",
            verts:[[551.925,512.063]]
            },{
            name:"72",
            tipo:"72",
            verts:[[701.452,428.621]]
            },{
            name:"73",
            tipo:"73",
            verts:[[770.647,390.028]]
            },{
            name:"96",
            tipo:"96",
            verts:[[846.944,347.49]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1540.82,357.666]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1594.7,404.407]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1644.43,447.479]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1754.8,542.847]]
            },],[{
            name:"49",
            tipo:"49",
            verts:[[547.503,495.008]]
            },{
            name:"72",
            tipo:"72",
            verts:[[713.459,418.418]]
            },{
            name:"73",
            tipo:"73",
            verts:[[791.526,382.418]]
            },{
            name:"96",
            tipo:"96",
            verts:[[878.56,342.305]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1570.83,364.298]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1610.33,413.414]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1647.02,458.979]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1729.29,560.922]]
            },],[{
            name:"49",
            tipo:"49",
            verts:[[549.249,478.617]]
            },{
            name:"72",
            tipo:"72",
            verts:[[728.19,408.803]]
            },{
            name:"73",
            tipo:"73",
            verts:[[813.895,375.4]]
            },{
            name:"96",
            tipo:"96",
            verts:[[910.629,337.726]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1600.08,371.684]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1623.58,423.056]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1645.51,470.934]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1695.04,578.828]]
            },],[{
            name:"49",
            tipo:"49",
            verts:[[556.342,463.019]]
            },{
            name:"72",
            tipo:"72",
            verts:[[745.272,399.791]]
            },{
            name:"73",
            tipo:"73",
            verts:[[837.523,368.96]]
            },{
            name:"96",
            tipo:"96",
            verts:[[943.057,333.723]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1628.4,379.864]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1634.13,433.321]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1639.5,483.259]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1651.69,596.201]]
            },],[{
            name:"49",
            tipo:"49",
            verts:[[568.047,448.29]]
            },{
            name:"72",
            tipo:"72",
            verts:[[764.391,391.391]]
            },{
            name:"73",
            tipo:"73",
            verts:[[862.225,363.088]]
            },{
            name:"96",
            tipo:"96",
            verts:[[975.781,330.274]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1599.09,612.606]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1628.56,495.837]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1641.59,444.188]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1655.53,388.883]]
            },],[{
            name:"49",
            tipo:"49",
            verts:[[583.704,434.477]]
            },{
            name:"72",
            tipo:"72",
            verts:[[785.275,383.607]]
            },{
            name:"73",
            tipo:"73",
            verts:[[887.848,357.775]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1008.75,327.372]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1537.42,627.553]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1612.26,508.522]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1645.5,455.616]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1681.18,398.791]]
            },],[{
            name:"49",
            tipo:"49",
            verts:[[602.744,421.605]]
            },{
            name:"72",
            tipo:"72",
            verts:[[807.698,376.448]]
            },{
            name:"73",
            tipo:"73",
            verts:[[914.267,353.027]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1041.93,325.023]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1467.26,640.494]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1590.23,521.115]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1645.38,467.54]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1704.96,409.636]]
            },],[{
            name:"49",
            tipo:"49",
            verts:[[624.581,409.684]]
            },{
            name:"72",
            tipo:"72",
            verts:[[831.417,369.909]]
            },{
            name:"73",
            tipo:"73",
            verts:[[941.344,348.832]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1075.27,323.215]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1389.71,650.959]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1562.24,533.404]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1640.77,479.867]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1726.44,421.447]]
            },],[{
            name:"49",
            tipo:"49",
            verts:[[648.705,398.705]]
            },{
            name:"72",
            tipo:"72",
            verts:[[856.221,363.987]]
            },{
            name:"73",
            tipo:"73",
            verts:[[968.959,345.188]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1108.74,321.949]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1306.3,658.512]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1528.19,545.141]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1631.21,492.475]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1745.13,434.244]]
            },],[{
            name:"49",
            tipo:"49",
            verts:[[674.594,388.632]]
            },{
            name:"72",
            tipo:"72",
            verts:[[881.892,358.662]]
            },{
            name:"73",
            tipo:"73",
            verts:[[996.991,342.069]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1142.29,321.203]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1218.88,662.883]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1488.16,556.092]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1616.34,505.229]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1760.53,448.031]]
            },],[{
            name:"49",
            tipo:"49",
            verts:[[701.797,379.394]]
            },{
            name:"72",
            tipo:"72",
            verts:[[908.249,353.917]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1025.34,339.466]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1129.46,663.849]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1175.89,320.974]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1442.42,566.005]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1595.8,517.964]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1772.03,462.805]]
            },],[{
            name:"49",
            tipo:"49",
            verts:[[729.898,370.859]]
            },{
            name:"72",
            tipo:"72",
            verts:[[935.124,349.733]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1040.01,661.185]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1053.93,337.371]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1209.52,321.265]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1391.34,574.609]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1569.3,530.477]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1778.93,478.534]]
            },],[{
            name:"49",
            tipo:"49",
            verts:[[758.555,362.771]]
            },{
            name:"60",
            tipo:"60",
            verts:[[952.493,654.486]]
            },{
            name:"72",
            tipo:"72",
            verts:[[962.347,346.092]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1082.65,335.791]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1243.14,322.099]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1335.49,581.609]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1536.62,542.52]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1780.4,495.144]]
            },],[{
            name:"49",
            tipo:"49",
            verts:[[787.652,354.703]]
            },{
            name:"60",
            tipo:"60",
            verts:[[869.101,643.164]]
            },{
            name:"72",
            tipo:"72",
            verts:[[989.701,342.919]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1111.4,334.705]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1275.56,586.698]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1276.72,323.475]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1497.7,553.834]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1775.66,512.528]]
            },],[{
            name:"60",
            tipo:"60",
            verts:[[793.018,627.008]]
            },{
            name:"49",
            tipo:"49",
            verts:[[817.695,346.442]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1016.97,340.075]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1140.04,334.103]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1212.33,589.365]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1310.18,325.429]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1452.56,564.058]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1763.74,530.494]]
            },],[{
            name:"60",
            tipo:"60",
            verts:[[727.348,607.621]]
            },{
            name:"49",
            tipo:"49",
            verts:[[849.278,338.501]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1043.99,337.228]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1146.89,588.805]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1168.37,333.91]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1343.42,327.973]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1401.38,572.736]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1743.74,548.779]]
            },],[{
            name:"60",
            tipo:"60",
            verts:[[672.961,587.29]]
            },{
            name:"49",
            tipo:"49",
            verts:[[882.224,331.598]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1071.03,333.953]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1081.27,584.143]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1196.2,333.905]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1344.57,579.184]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1376.34,331.095]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1714.86,567.043]]
            },],[{
            name:"60",
            tipo:"60",
            verts:[[629.281,567.101]]
            },{
            name:"49",
            tipo:"49",
            verts:[[915.983,325.942]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1018.58,575.714]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1098.85,330.397]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1223.49,333.699]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1283.11,582.299]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1408.74,334.771]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1676.25,584.751]]
            },],[{
            name:"60",
            tipo:"60",
            verts:[[595.495,547.333]]
            },{
            name:"49",
            tipo:"49",
            verts:[[950.136,321.388]]
            },{
            name:"61",
            tipo:"61",
            verts:[[960.892,565.423]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1127.76,327.364]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1219.33,581.302]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1250.73,332.986]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1440.38,338.867]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1627.35,601.112]]
            },],[{
            name:"60",
            tipo:"60",
            verts:[[570.794,528.098]]
            },{
            name:"61",
            tipo:"61",
            verts:[[908.517,554.613]]
            },{
            name:"49",
            tipo:"49",
            verts:[[984.456,317.735]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1156.16,577.178]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1157.35,325.328]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1278.66,332.207]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1471.11,343.056]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1568.13,614.947]]
            },],[{
            name:"60",
            tipo:"60",
            verts:[[554.482,509.47]]
            },{
            name:"61",
            tipo:"61",
            verts:[[861.474,543.486]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1018.85,314.857]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1095,571.642]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1187.2,324.282]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1307.29,332.174]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1499.78,624.847]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1501.11,346.943]]
            },],[{
            name:"60",
            tipo:"60",
            verts:[[545.723,491.569]]
            },{
            name:"61",
            tipo:"61",
            verts:[[819.941,531.989]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1036.18,565.37]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1053.26,312.648]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1217.05,324.061]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1336.12,333.165]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1425.05,630.659]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1531.1,350.601]]
            },],[{
            name:"60",
            tipo:"60",
            verts:[[543.693,474.492]]
            },{
            name:"61",
            tipo:"61",
            verts:[[784.153,520.101]]
            },{
            name:"84",
            tipo:"84",
            verts:[[980.208,558.27]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1087.65,311.047]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1246.8,324.535]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1346.18,633.766]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1364.8,335.094]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1561.41,354.807]]
            },],[{
            name:"60",
            tipo:"60",
            verts:[[547.594,458.319]]
            },{
            name:"61",
            tipo:"61",
            verts:[[754.261,507.888]]
            },{
            name:"84",
            tipo:"84",
            verts:[[927.865,550.175]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1122,310.018]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1264.13,635.077]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1276.36,325.628]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1393.1,337.832]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1591.61,360.158]]
            },],[{
            name:"60",
            tipo:"60",
            verts:[[556.699,443.102]]
            },{
            name:"61",
            tipo:"61",
            verts:[[730.316,495.463]]
            },{
            name:"84",
            tipo:"84",
            verts:[[879.97,541.03]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1156.31,309.554]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1180.02,634.415]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1305.68,327.311]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1420.85,341.297]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1621.07,366.76]]
            },],[{
            name:"60",
            tipo:"60",
            verts:[[570.237,428.883]]
            },{
            name:"61",
            tipo:"61",
            verts:[[712.162,482.986]]
            },{
            name:"84",
            tipo:"84",
            verts:[[837.176,530.936]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1095.58,631.408]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1190.54,309.631]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1334.68,329.55]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1447.95,345.428]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1649.35,374.521]]
            },],[{
            name:"60",
            tipo:"60",
            verts:[[587.534,415.679]]
            },{
            name:"61",
            tipo:"61",
            verts:[[699.544,470.609]]
            },{
            name:"84",
            tipo:"84",
            verts:[[799.956,520.05]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1012.91,625.818]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1224.66,310.241]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1363.29,332.333]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1474.24,350.196]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1676.04,383.348]]
            },],[{
            name:"60",
            tipo:"60",
            verts:[[607.917,403.481]]
            },{
            name:"61",
            tipo:"61",
            verts:[[692.049,458.478]]
            },{
            name:"84",
            tipo:"84",
            verts:[[768.508,508.594]]
            },{
            name:"85",
            tipo:"85",
            verts:[[934.032,617.696]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1258.67,311.358]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1391.45,335.639]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1499.61,355.568]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1700.82,393.173]]
            },],[{
            name:"60",
            tipo:"60",
            verts:[[630.84,392.26]]
            },{
            name:"61",
            tipo:"61",
            verts:[[689.25,446.705]]
            },{
            name:"84",
            tipo:"84",
            verts:[[742.867,496.771]]
            },{
            name:"85",
            tipo:"85",
            verts:[[860.743,607.237]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1292.55,312.975]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1419.07,339.462]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1523.91,361.535]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1723.3,403.961]]
            },],[{
            name:"60",
            tipo:"60",
            verts:[[655.854,381.978]]
            },{
            name:"61",
            tipo:"61",
            verts:[[690.716,435.375]]
            },{
            name:"84",
            tipo:"84",
            verts:[[722.929,484.771]]
            },{
            name:"85",
            tipo:"85",
            verts:[[794.489,594.743]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1326.28,315.093]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1446.06,343.806]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1546.95,368.097]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1743.05,415.691]]
            },],[{
            name:"60",
            tipo:"60",
            verts:[[682.598,372.599]]
            },{
            name:"61",
            tipo:"61",
            verts:[[696.034,424.554]]
            },{
            name:"84",
            tipo:"84",
            verts:[[708.494,472.76]]
            },{
            name:"85",
            tipo:"85",
            verts:[[736.336,580.574]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1359.81,317.733]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1472.3,348.689]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1568.52,375.263]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1759.51,428.344]]
            },],[{
            name:"85",
            tipo:"85",
            verts:[[686.858,565.172]]
            },{
            name:"84",
            tipo:"84",
            verts:[[699.212,460.898]]
            },{
            name:"61",
            tipo:"61",
            verts:[[704.746,414.292]]
            },{
            name:"60",
            tipo:"60",
            verts:[[710.716,364.072]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1393.13,320.894]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1497.66,354.111]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1588.38,383.024]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1772.13,441.886]]
            },],[{
            name:"85",
            tipo:"85",
            verts:[[646.34,548.919]]
            },{
            name:"84",
            tipo:"84",
            verts:[[694.757,449.305]]
            },{
            name:"61",
            tipo:"61",
            verts:[[716.491,404.623]]
            },{
            name:"60",
            tipo:"60",
            verts:[[739.973,356.367]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1426.16,324.61]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1521.96,360.096]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1606.23,391.387]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1780.2,456.261]]
            },],[{
            name:"85",
            tipo:"85",
            verts:[[614.667,532.208]]
            },{
            name:"84",
            tipo:"84",
            verts:[[694.716,438.089]]
            },{
            name:"61",
            tipo:"61",
            verts:[[730.885,395.572]]
            },{
            name:"60",
            tipo:"60",
            verts:[[770.132,349.442]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1458.83,328.9]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1545.01,366.651]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1621.75,400.337]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1783,471.381]]
            },],[{
            name:"85",
            tipo:"85",
            verts:[[591.389,515.41]]
            },{
            name:"84",
            tipo:"84",
            verts:[[698.615,427.336]]
            },{
            name:"61",
            tipo:"61",
            verts:[[747.542,387.143]]
            },{
            name:"60",
            tipo:"60",
            verts:[[800.972,343.246]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1491.07,333.77]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1566.62,373.773]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1634.63,409.85]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1779.84,487.129]]
            },],[{
            name:"85",
            tipo:"85",
            verts:[[575.967,498.802]]
            },{
            name:"84",
            tipo:"84",
            verts:[[706.056,417.105]]
            },{
            name:"61",
            tipo:"61",
            verts:[[766.163,379.342]]
            },{
            name:"60",
            tipo:"60",
            verts:[[832.349,337.747]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1522.77,339.25]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1586.53,381.469]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1644.46,419.894]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1769.92,503.335]]
            },],[{
            name:"85",
            tipo:"85",
            verts:[[567.678,482.622]]
            },{
            name:"84",
            tipo:"84",
            verts:[[716.612,407.439]]
            },{
            name:"61",
            tipo:"61",
            verts:[[786.452,372.158]]
            },{
            name:"60",
            tipo:"60",
            verts:[[864.123,332.904]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1553.81,345.362]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1604.48,389.734]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1650.88,430.422]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1752.54,519.787]]
            },],[{
            name:"85",
            tipo:"85",
            verts:[[565.685,467.056]]
            },{
            name:"84",
            tipo:"84",
            verts:[[729.844,398.356]]
            },{
            name:"61",
            tipo:"61",
            verts:[[808.12,365.566]]
            },{
            name:"60",
            tipo:"60",
            verts:[[896.163,328.661]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1584.07,352.112]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1620.23,398.55]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1653.53,441.374]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1727.13,536.247]]
            },],[{
            name:"85",
            tipo:"85",
            verts:[[569.268,452.218]]
            },{
            name:"84",
            tipo:"84",
            verts:[[745.424,389.867]]
            },{
            name:"61",
            tipo:"61",
            verts:[[830.966,359.552]]
            },{
            name:"60",
            tipo:"60",
            verts:[[928.402,324.992]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1613.37,359.538]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1633.43,407.907]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1651.97,452.672]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1693.16,552.393]]
            },],[{
            name:"85",
            tipo:"85",
            verts:[[577.66,438.185]]
            },{
            name:"84",
            tipo:"84",
            verts:[[763.011,381.965]]
            },{
            name:"61",
            tipo:"61",
            verts:[[854.787,354.085]]
            },{
            name:"60",
            tipo:"60",
            verts:[[960.767,321.854]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1641.55,367.662]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1643.77,417.78]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1645.82,464.223]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1650.37,567.883]]
            },],[{
            name:"85",
            tipo:"85",
            verts:[[590.19,424.995]]
            },{
            name:"84",
            tipo:"84",
            verts:[[782.324,374.64]]
            },{
            name:"61",
            tipo:"61",
            verts:[[879.426,349.141]]
            },{
            name:"60",
            tipo:"60",
            verts:[[993.214,319.219]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1598.71,582.323]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1634.7,475.909]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1650.87,428.136]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1668.35,376.514]]
            },],[{
            name:"85",
            tipo:"85",
            verts:[[606.275,412.662]]
            },{
            name:"84",
            tipo:"84",
            verts:[[803.128,367.877]]
            },{
            name:"61",
            tipo:"61",
            verts:[[904.755,344.7]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1025.71,317.068]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1538.48,595.276]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1618.26,487.584]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1654.34,438.926]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1693.5,386.129]]
            },],[{
            name:"85",
            tipo:"85",
            verts:[[625.434,401.186]]
            },{
            name:"84",
            tipo:"84",
            verts:[[825.238,361.671]]
            },{
            name:"61",
            tipo:"61",
            verts:[[930.677,340.757]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1058.25,315.399]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1470.34,606.263]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1596.17,499.06]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1653.7,450.077]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1716.61,396.538]]
            },],[{
            name:"85",
            tipo:"85",
            verts:[[647.185,390.553]]
            },{
            name:"84",
            tipo:"84",
            verts:[[848.455,356.002]]
            },{
            name:"61",
            tipo:"61",
            verts:[[957.084,337.289]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1090.79,314.193]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1395.46,614.878]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1568.28,510.138]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1648.57,461.495]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1737.29,407.756]]
            },],[{
            name:"85",
            tipo:"85",
            verts:[[671.146,380.745]]
            },{
            name:"84",
            tipo:"84",
            verts:[[872.622,350.852]]
            },{
            name:"61",
            tipo:"61",
            verts:[[983.892,334.278]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1123.31,313.439]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1315.44,620.762]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1534.56,520.589]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1638.55,473.058]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1755.07,419.786]]
            },],[{
            name:"85",
            tipo:"85",
            verts:[[696.964,371.729]]
            },{
            name:"84",
            tipo:"84",
            verts:[[897.586,346.186]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1011.02,331.69]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1155.8,313.106]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1232.29,623.725]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1495.22,530.199]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1623.34,484.633]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1769.49,432.621]]
            },],[{
            name:"85",
            tipo:"85",
            verts:[[724.413,363.496]]
            },{
            name:"84",
            tipo:"84",
            verts:[[923.246,341.978]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1038.42,329.502]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1148.26,623.702]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1188.26,313.181]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1450.61,538.743]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1602.7,496.062]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1780.03,446.244]]
            },],[{
            name:"85",
            tipo:"85",
            verts:[[753.369,356.09]]
            },{
            name:"84",
            tipo:"84",
            verts:[[949.547,338.211]]
            },{
            name:"96",
            tipo:"96",
            verts:[[1065.77,620.854]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1066.05,327.7]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1220.69,313.659]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1401.31,546.001]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1576.44,507.161]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1786.05,460.614]]
            },],[{
            name:"85",
            tipo:"85",
            verts:[[783.766,349.689]]
            },{
            name:"96",
            tipo:"96",
            verts:[[987.263,615.711]]
            },{
            name:"84",
            tipo:"84",
            verts:[[976.478,334.892]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1093.92,326.281]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1253.1,314.551]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1348.12,551.775]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1544.52,517.715]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1786.84,475.659]]
            },],[{
            name:"85",
            tipo:"85",
            verts:[[815.344,344.62]]
            },{
            name:"96",
            tipo:"96",
            verts:[[914.543,609.367]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1004.06,332.045]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1122.03,325.235]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1292.17,556]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1285.48,315.847]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1507.12,527.526]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1781.76,491.277]]
            },],[{
            name:"96",
            tipo:"96",
            verts:[[847.996,602.704]]
            },{
            name:"85",
            tipo:"85",
            verts:[[847.403,341.111]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1032.39,329.811]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1150.43,324.598]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1234.81,558.786]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1317.85,317.575]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1464.59,536.385]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1770.04,507.306]]
            },],[{
            name:"96",
            tipo:"96",
            verts:[[787.062,595.145]]
            },{
            name:"85",
            tipo:"85",
            verts:[[879.048,338.668]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1061.5,328.49]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1177.42,560.693]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1179.2,324.442]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1350.22,319.751]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1417.64,544.209]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1751.04,523.546]]
            },],[{
            name:"96",
            tipo:"96",
            verts:[[732.264,585.391]]
            },{
            name:"85",
            tipo:"85",
            verts:[[910.109,336.476]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1091.04,328.476]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1120.65,562.61]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1208.46,324.945]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1367.27,551.209]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1382.64,322.389]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1724.35,539.794]]
            },],[{
            name:"96",
            tipo:"96",
            verts:[[684.991,573.151]]
            },{
            name:"85",
            tipo:"85",
            verts:[[940.96,334.242]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1064.01,564.404]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1120.17,329.711]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1238.17,326.506]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1314.3,557.997]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1415.17,325.568]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1689.65,555.845]]
            },],[{
            name:"96",
            tipo:"96",
            verts:[[646.065,559.02]]
            },{
            name:"85",
            tipo:"85",
            verts:[[971.874,332.039]]
            },{
            name:"73",
            tipo:"73",
            verts:[[1007.64,564.462]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1148.39,331.399]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1258.65,565.128]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1267.8,329.471]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1447.93,329.44]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1647.01,571.657]]
            },],[{
            name:"96",
            tipo:"96",
            verts:[[615.539,543.743]]
            },{
            name:"73",
            tipo:"73",
            verts:[[953.201,561.743]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1002.94,329.985]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1175.96,332.969]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1199.73,571.658]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1296.5,333.448]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1480.99,334.319]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1596.69,587.571]]
            },],[{
            name:"96",
            tipo:"96",
            verts:[[593.143,527.883]]
            },{
            name:"73",
            tipo:"73",
            verts:[[902.439,556.361]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1034.18,328.192]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1138.48,575.718]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1203.26,334.409]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1324.08,337.639]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1514.02,340.681]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1538.35,604.079]]
            },],[{
            name:"96",
            tipo:"96",
            verts:[[578.285,511.891]]
            },{
            name:"73",
            tipo:"73",
            verts:[[856.453,548.868]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1077.03,576.616]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1065.57,326.71]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1230.45,335.863]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1350.91,341.713]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1470.95,620.7]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1546.18,348.584]]
            },],[{
            name:"96",
            tipo:"96",
            verts:[[570.297,496.081]]
            },{
            name:"73",
            tipo:"73",
            verts:[[815.885,539.779]]
            },{
            name:"72",
            tipo:"72",
            verts:[[1017.27,574.589]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1097.11,325.576]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1257.58,337.468]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1394.46,635.299]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1377.26,345.758]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1576.79,357.362]]
            },],[{
            name:"96",
            tipo:"96",
            verts:[[568.489,480.679]]
            },{
            name:"73",
            tipo:"73",
            verts:[[781.083,529.513]]
            },{
            name:"72",
            tipo:"72",
            verts:[[960.603,570.078]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1128.78,324.82]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1284.65,339.322]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1311.01,646.079]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1403.2,349.941]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1605.89,366.444]]
            },],[{
            name:"96",
            tipo:"96",
            verts:[[572.21,465.839]]
            },{
            name:"73",
            tipo:"73",
            verts:[[752.215,518.399]]
            },{
            name:"72",
            tipo:"72",
            verts:[[908.11,563.471]]
            },{
            name:"85",
            tipo:"85",
            verts:[[1160.56,324.477]]
            },{
            name:"49",
            tipo:"49",
            verts:[[1223.47,652.495]]
            },{
            name:"84",
            tipo:"84",
            verts:[[1311.6,341.507]]
            },{
            name:"61",
            tipo:"61",
            verts:[[1428.69,354.406]]
            },{
            name:"60",
            tipo:"60",
            verts:[[1633.67,375.779]]
            },],]
    }
}